import GridLayout, { WidthProvider, type Layout } from 'react-grid-layout';
import { Box } from '@mui/material';
import PanelCard from './PanelCard';
import type { DashboardConfig, DashboardPanel } from './types';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const Grid = WidthProvider(GridLayout);

export default function DashboardCanvas({
  dashboard, editMode, onLayoutChange, onEditPanel, onDuplicatePanel, onDeletePanel,
}: {
  dashboard: DashboardConfig;
  editMode: boolean;
  onLayoutChange: (layout: Layout[]) => void;
  onEditPanel: (panel: DashboardPanel) => void;
  onDuplicatePanel: (panel: DashboardPanel) => void;
  onDeletePanel: (panel: DashboardPanel) => void;
}) {
  const layout: Layout[] = dashboard.panels.map((p) => ({
    i: p.id, x: p.layout.x, y: p.layout.y, w: p.layout.w, h: p.layout.h, minW: 2, minH: 2,
  }));

  return (
    <Box sx={(theme) => ({
      // The react-resizable corner grip ships as a dark SVG; invert it in dark mode so
      // it stays visible, and lift its opacity a touch for discoverability.
      '& .react-resizable-handle': {
        opacity: theme.palette.mode === 'dark' ? 0.75 : 0.5,
        filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      },
    })}
    >
      <Grid
        className="layout"
        layout={layout}
        cols={12}
        rowHeight={48}
        margin={[12, 12]}
        containerPadding={[0, 0]}
        isDraggable={editMode}
        isResizable={editMode}
        draggableHandle=".panel-drag-handle"
        draggableCancel=".MuiIconButton-root"
        onLayoutChange={(l) => { if (editMode) onLayoutChange(l); }}
      >
        {dashboard.panels.map((p) => (
          <Box key={p.id}>
            <PanelCard
              dashboard={dashboard}
              panel={p}
              editMode={editMode}
              onEdit={() => onEditPanel(p)}
              onDuplicate={() => onDuplicatePanel(p)}
              onDelete={() => onDeletePanel(p)}
            />
          </Box>
        ))}
      </Grid>
    </Box>
  );
}
